import React from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import SkillAdd from '../../components/Skill/SkillAdd';

function SkillAddPage() {
    return (
        <div className="body d-flex py-lg-3 py-md-2">
            <div className="container-xxl">
            <button
                onClick={() => window.history.back()}
                style={{
                    marginBottom: "10px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "monospace",
                    fontSize: "18px",
                    color: "#007bff",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    padding: "10px 20px",
                }}
            >
                <span style={{ marginRight: "8px" }}>&lt;</span>
                <span style={{ position: "relative", display: "inline-block" }}>
                    Back
                    <span
                        style={{
                            content: "''",
                            position: "absolute",
                            left: 0,
                            bottom: -2,
                            width: "100%",
                            height: "1px",
                            borderBottom: "2px solid #007bff",
                        }}
                    ></span>
                </span>
            </button>
                {/* <PageHeader1 pagetitle='skill Add' /> */}
                <div className="row clearfix g-3">
                    <div className="col-lg-12">
                        <SkillAdd />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SkillAddPage;